/* battery-story — runtime for the battery-pack story band.
 *
 * Deliberately not t330-story.js (59 KB of configurator-gate plumbing a
 * battery page has no use for). Three jobs:
 *   1. pill tabs  ([data-bps-tabs]: .bps-tab <-> .bps-panel by index)
 *   2. accordion  ([data-bps-acc]: one row open at a time, its picture shown)
 *   3. reveal on scroll (.bps-io -> .is-in; skipped for reduced motion)
 * plus the theme-editor hooks so a re-rendered section or a selected block
 * behaves. ES5 on purpose, like the rest of the theme's own scripts.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  /* ---------- tabs ---------- */

  function selectTab(group, index, focus) {
    var tabs = toArray(group.querySelectorAll(':scope > .bps-tabs__bar > .bps-tab'));
    var panels = toArray(group.querySelectorAll(':scope > .bps-panel'));
    for (var i = 0; i < tabs.length; i++) {
      var on = i === index;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].tabIndex = on ? 0 : -1;
      if (panels[i]) panels[i].hidden = !on;
      if (on && focus) tabs[i].focus();
    }
    group.dataset.bpsActive = String(index);
  }

  function initTabs(root) {
    var groups = root.querySelectorAll('[data-bps-tabs]');
    for (var g = 0; g < groups.length; g++) {
      (function (group) {
        if (group.dataset.bpsReady === '1') return;
        group.dataset.bpsReady = '1';
        var tabs = toArray(group.querySelectorAll(':scope > .bps-tabs__bar > .bps-tab'));
        if (!tabs.length) return;
        tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { selectTab(group, i, false); });
          tab.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = tabs.length - 1;
            if (next === null) return;
            e.preventDefault();
            selectTab(group, next, true);
          });
        });
        selectTab(group, 0, false);

        /* A rail too narrow for its pills scrolls sideways, and a pill cut off
           at the edge reads as broken rather than as "there is more" (Bill
           2026-09-15). Mark which end is hidden so the CSS can fade it, and
           keep the selected pill in view when the reader moves by keyboard. */
        var bar = group.querySelector(':scope > .bps-tabs__bar');
        if (bar) {
          var markEdges = function () {
            var slack = bar.scrollWidth - bar.clientWidth;
            if (slack < 2) { delete bar.dataset.bpsOverflow; delete bar.dataset.bpsEdge; return; }
            bar.dataset.bpsOverflow = '1';
            var x = bar.scrollLeft;
            bar.dataset.bpsEdge = x < 2 ? 'start' : (x >= slack - 2 ? 'end' : 'middle');
          };
          bar.addEventListener('scroll', markEdges, { passive: true });
          if (typeof ResizeObserver === 'function') new ResizeObserver(markEdges).observe(bar);
          window.addEventListener('resize', markEdges);
          markEdges();
          tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
              if (tab.scrollIntoView) tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
            });
          });
        }
      })(groups[g]);
    }
  }

  /* ---------- accordion ---------- */

  function openRow(acc, index) {
    var items = toArray(acc.querySelectorAll(':scope > .bps-acc__items > .bps-acc__item'));
    var panes = toArray(acc.querySelectorAll(':scope > .bps-acc__media > [data-acc-pane]'));
    for (var i = 0; i < items.length; i++) {
      var on = i === index;
      items[i].classList.toggle('open', on);
      var head = items[i].querySelector('.bps-acc__head');
      if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    for (var p = 0; p < panes.length; p++) panes[p].classList.toggle('on', p === index);
  }

  function initAccordions(root) {
    var accs = root.querySelectorAll('[data-bps-acc]');
    for (var a = 0; a < accs.length; a++) {
      (function (acc) {
        if (acc.dataset.bpsReady === '1') return;
        acc.dataset.bpsReady = '1';
        var items = toArray(acc.querySelectorAll(':scope > .bps-acc__items > .bps-acc__item'));
        items.forEach(function (item, i) {
          var head = item.querySelector('.bps-acc__head');
          if (!head) return;
          head.addEventListener('click', function () {
            // The open row stays open: the picture on the right belongs to it,
            // and a panel with every row shut would show nothing.
            if (!item.classList.contains('open')) openRow(acc, i);
          });
        });
        var first = -1;
        for (var i = 0; i < items.length; i++) if (items[i].classList.contains('open')) { first = i; break; }
        openRow(acc, first < 0 ? 0 : first);
      })(accs[a]);
    }
  }

  /* ---------- reveal ---------- */

  function initReveal(root) {
    var nodes = toArray(root.querySelectorAll('.bps-io:not(.is-in)'));
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-in');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- boot ---------- */

  function init(root) {
    root = root || document;
    initTabs(root);
    initAccordions(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: a re-rendered section arrives with fresh, unwired nodes.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-bps]')) init(event.target);
  });

  // Theme editor: selecting a tab or accordion-row block brings it on screen,
  // otherwise the merchandiser edits a hidden panel blind.
  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el || !el.closest) return;
    var item = el.classList.contains('bps-acc__item') ? el : null;
    var panel = el.closest('.bps-panel');
    if (!panel) return;
    var group = panel.parentNode;
    var panels = toArray(group.querySelectorAll(':scope > .bps-panel'));
    selectTab(group, panels.indexOf(panel), false);
    if (item) {
      var acc = item.closest('[data-bps-acc]');
      var items = toArray(acc.querySelectorAll(':scope > .bps-acc__items > .bps-acc__item'));
      openRow(acc, items.indexOf(item));
    }
  });
})();
